var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"swagger"},[_c('openapi-explorer',{attrs:{"spec-url":"https://rixtrema.net/api/external/swagger/docs/v1/PlansApi","nav-bg-color":"#18334d"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }